
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Grid from 'plaid-threads/Grid';
import Column from 'plaid-threads/Column';
import Actions from '../../../components/docs/Actions';

export const metadata = {
  toc: true,
  layout: 'guide',
  description: 'External resources to help build your Plaid integration'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header title='Plaid resources' subtitle={metadata.description} mdxType="Header" />
    <p>{`In addition to the docs here, Plaid has a collection of tools, sample code,
SDKs, and videos to help you build your Plaid integration.`}</p>
    <h4 {...{
      "id": "sample-apps"
    }}>{`Sample apps`}</h4>
    <p>{`Our `}<a parentName="p" {...{
        "href": "https://github.com/plaid"
      }}>{`GitHub`}</a>{` contains a number of sample apps to help
you get started using Plaid!`}</p>
    <Actions.MediaCardGrid>
  <Actions.MediaCard title='Quickstart' href='https://github.com/plaid/quickstart' imageSrc='/assets/img/docs/quickstart.jpeg' category='code' subtitle='Official Plaid Quickstart, using React, available in NodeJS, Python, Ruby, Java, and Go' />
  <Actions.MediaCard title='Tiny Quickstart' href='https://github.com/plaid/tiny-quickstart' category='code' imageSrc='/assets/img/docs/tiny-quickstart.png' subtitle='A Plaid implementation in 150 lines. Available in JavaScript, Next.js, React, and React Native frontends.' />
  <Actions.MediaCard title='Personal Finances' href='https://github.com/plaid/pattern' category='code' imageSrc='/assets/img/docs/pattern-square.png' subtitle='Usages of Transactions, Assets, and Liabilities APIs, using NodeJS and React' />
  <Actions.MediaCard title='Account Funding' href='https://github.com/plaid/pattern-account-funding/' imageSrc='/assets/img/docs/pattern_account_funding_screenshot.png' category='code' subtitle='Auth, Identity, and Balance APIs for money movement, in NodeJS and React' />
  <Actions.MediaCard title='Account Funding in Europe' href='https://github.com/plaid/payment-initiation-pattern-app/' imageSrc='/assets/img/docs/pattern_account_funding_europe_screenshot.png' category='code' subtitle='Account funding using the Payment Initiation API, using NodeJS and React' />
    <Actions.MediaCard title='Transfer Quickstart' href='https://github.com/plaid/transfer-quickstart' imageSrc='/assets/img/docs/transfer-quickstart-screenshot.png' category='code' subtitle='Use Transfer to receive funds from customers, using NodeJS and JavaScript' />
  <Actions.MediaCard title='Identity Verification Quickstart' href='https://github.com/plaid/idv-quickstart' imageSrc='/assets/img/docs/idv_quickstart_screenshot.png' category='code' subtitle='See Plaid Identity Verification in action! (NodeJS only)' />
  <Actions.MediaCard title='Layer Quickstart' href='https://github.com/plaid/layer-quickstart' imageSrc='/assets/img/docs/layer-quickstart.png' category='code' subtitle='Use Layer to quickly onboard customers, using NodeJS and React' />
    <Actions.MediaCard title='Plaid Check (CRA) Quickstart' href='https://github.com/plaid/credit-quickstart' imageSrc='/assets/img/docs/cra-quickstart-screenshot.png' category='code' subtitle='A lending app using the Plaid Check (CRA) API, using NodeJS and React' />
  <Actions.MediaCard title='Income Quickstart' href='https://github.com/plaid/income-sample' imageSrc='/assets/img/docs/income_sample_screenshot.png' category='code' subtitle='A lending app using the Income API, using NodeJS and React' />
    </Actions.MediaCardGrid>
    <h4 {...{
      "id": "demos-video-tutorials-and-guides"
    }}>{`Demos, video tutorials, and guides`}</h4>
    <h5 {...{
      "id": "demos"
    }}>{`Demos`}</h5>
    <p><a parentName="p" {...{
        "href": "https://demo.plaid.com"
      }}>{`demo.plaid.com`}</a>{` features interactive demos showing API calls alongside the end user experience for many Plaid products and use cases, including account funding and verification, personal financial management with Transactions, credit and underwriting, pay-by-bank, and more.`}</p>
    <p>{`For the older demo page that just shows the Link UI rather than a full integration experience, see `}<a parentName="p" {...{
        "href": "https://plaid.com/link-demo"
      }}>{`Link demo`}</a>{`.`}</p>
    <h5 {...{
      "id": "video-tutorials"
    }}>{`Video tutorials`}</h5>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/playlist?list=PLyKH4ZiEQ1bH5wpCt9SiyVfHlV2HecFBq"
      }}>{`Plaid Academy`}</a>{` features detailed tutorial walkthroughs for common use cases and key concepts, several with accompanying repos.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/playlist?list=PLyKH4ZiEQ1bE7XBcpX81BQWLy1olem1wf"
      }}>{`Plaid in 3 Minutes`}</a>{` contains overviews of different Plaid APIs, as well as short tutorials for busy people. `}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/playlist?list=PLyKH4ZiEQ1bEAnnIiFMRGat7tFQl3gcJv"
      }}>{`Plaid Quick Tips`}</a>{` has snack-sized solutions to pressing Plaid problems.`}</p>
    <p>{`The playlist below contains all of Plaid's up-to-date educational videos.`}</p>
    <iframe width="560" height="315" src="https://www.youtube.com/embed/videoseries?si=cPMjJYyoCdpbProV&amp;list=PLyKH4ZiEQ1bGJQXLNhrKQtQK8ADWTDJ0Y" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
    <h5 {...{
      "id": "launch-center"
    }}>{`Launch center`}</h5>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/developers/launch-center"
      }}>{`Launch Center`}</a>{` provides a list of steps to help
make sure your app is Plaid-optimized and production ready.`}</p>
    <h4 {...{
      "id": "developer-tools"
    }}>{`Developer tools`}</h4>
    <p>{`Developer tools include our SDKs, Postman collection, and OpenAPI file.`}</p>
    <h5 {...{
      "id": "sdks"
    }}>{`SDKs`}</h5>
    <p>{`For information about official and community supported libraries for both the
Plaid API and the Link frontend component, see `}<a parentName="p" {...{
        "href": "/docs/api/libraries"
      }}>{`libraries`}</a>{`.`}</p>
    <h5 {...{
      "id": "postman"
    }}>{`Postman`}</h5>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://github.com/plaid/plaid-postman"
      }}>{`Postman Collection`}</a>{` provides an
easy, no-code way to explore the API.`}</p>
    <h5 {...{
      "id": "sandbox-studio"
    }}>{`Sandbox Studio`}</h5>
    <p><a parentName="p" {...{
        "href": "/docs/sandbox/studio"
      }}>{`Sandbox Studio`}</a>{` is a no-code way to explore Plaid
products from the Dashboard, using Sandbox test data.`}</p>
    <h5 {...{
      "id": "openapi-file"
    }}>{`OpenAPI file`}</h5>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://github.com/plaid/plaid-openapi"
      }}>{`Plaid OpenAPI file`}</a>{` is available on
GitHub. This file describes the Plaid API in a standardized way suitable for
usage with tools for testing, client library generation, and other purposes that
ingest OpenAPI/Swagger definition files.`}</p>
    <h5 {...{
      "id": "test-data-libraries"
    }}>{`Test data libraries`}</h5>
    <p><a parentName="p" {...{
        "href": "/docs/sandbox/studio/"
      }}>{`Sandbox Studio`}</a>{` includes ready-made templates for
`}<a parentName="p" {...{
        "href": "/docs/sandbox/user-custom/"
      }}>{`custom Sandbox users`}</a>{` covering each product, which
you can use as-is or edit to test apps in Sandbox.`}</p>
    <h5 {...{
      "id": "enrich-test-transaction-library"
    }}>{`Enrich test transaction library`}</h5>
    <p>{`For testing Enrich, Plaid provides a list of `}<a parentName="p" {...{
        "href": "https://plaid.com/documents/enrich_sandbox_preset_transactions.csv"
      }}>{`Sandbox-compatible Enrich transactions`}</a>{`.`}</p>
    <h5 {...{
      "id": "credit-attributes-library"
    }}>{`Credit attributes library`}</h5>
    <p>{`For the Assets and Income products, Plaid maintains a
`}<a parentName="p" {...{
        "href": "https://github.com/plaid/credit-attributes"
      }}>{`Credit attributes library`}</a>{` of helper
scripts that can be used to derive various useful attributes from an Asset
Report or Bank Income.`}</p>
    <h4 {...{
      "id": "ai-developer-tools"
    }}>{`AI developer tools`}</h4>
    <p>{`Plaid offers a number of tools to help you incorporate AI tooling into your development flow.`}</p>
    <h5 {...{
      "id": "plaid-cli"
    }}>{`Plaid CLI`}</h5>
    <p>{`The `}<a parentName="p" {...{
        "href": "/docs/resources/cli"
      }}>{`Plaid CLI`}</a>{` is a command-line interface for the Plaid API, designed for both developers and AI agents. Install via Homebrew, link a bank account, and start making API calls from the terminal. Pass `}<inlineCode parentName="p">{`--json`}</inlineCode>{` for structured output that agents and scripts can parse directly.`}</p>
    <h5 {...{
      "id": "dashboard-mcp-server"
    }}>{`Dashboard MCP server`}</h5>
    <p>{`Plaid's `}<a parentName="p" {...{
        "href": "/docs/resources/mcp"
      }}>{`Dashboard MCP server`}</a>{` allows you to access Plaid's diagnostics
and analytics tools to retrieve information about Link analytics, Item health, and more,
using your favorite LLM-powered application or client library.`}</p>
    <h5 {...{
      "id": "local-mcp-server"
    }}>{`Local MCP server`}</h5>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://github.com/plaid/ai-coding-toolkit/tree/main/sandbox"
      }}>{`Plaid AI coding toolkit`}</a>{` ships with a local
MCP server that runs as a subprocess of your MCP client (Claude Desktop, Cursor, VS Code, Zed, etc.) and provides
helpful utilities for building and testing your Plaid-powered applications.
You can use it to generate realistic looking `}<a parentName="p" {...{
        "href": "/docs/sandbox/user-custom/"
      }}>{`custom user data`}</a>{`,
simulate webhooks, create public tokens in the `}<a parentName="p" {...{
        "href": "/docs/sandbox"
      }}>{`Sandbox environment`}</a>{`, or
search Plaid's documentation directly from your AI coding assistant so it can pull in the right context without
you pasting URLs. (Not to be confused with the `}<a parentName="p" {...{
        "href": "/docs/resources/mcp"
      }}>{`Dashboard MCP server`}</a>{`, a remote MCP server
hosted by Plaid that provides production diagnostics and analytics tools.)`}</p>
    <h5 {...{
      "id": "llm-friendly-documentation"
    }}>{`LLM-friendly documentation`}</h5>
    <p>{`In accordance with the `}<a parentName="p" {...{
        "href": "https://llmstxt.org/"
      }}>{`llms-txt`}</a>{` proposal, an index of all
of Plaid's documentation can be found in LLM-friendly Markdown at
`}<a parentName="p" {...{
        "href": "https://plaid.com/docs/llms.txt"
      }}>{`https://plaid.com/docs/llms.txt`}</a>{`. You can find a Markdown equivalent of
Plaid documentation pages or API reference sections by clicking the document icon next to the header. You can also access Markdown pages by adding `}<inlineCode parentName="p">{`index.html.md`}</inlineCode>{` to the end of the URL. For example, a Markdown version of `}<a parentName="p" {...{
        "href": "https://plaid.com/docs/auth"
      }}>{`https://plaid.com/docs/auth`}</a>{` can be found at
`}<a parentName="p" {...{
        "href": "https://plaid.com/docs/auth/index.html.md"
      }}>{`https://plaid.com/docs/auth/index.html.md`}</a>{`. `}</p>
    <p>{`Consult the documentation for your favorite LLM-powered coding assistant
for the best way to incorporate this documentation into your workflow, as best
practices are changing frequently. Often, adding a prompt like the following
in your helper file can be useful.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-text",
        "metastring": "switcher=false #Sample prompt",
        "switcher": "false",
        "#Sample": true,
        "prompt": true
      }}>{`## Instructions on using the Plaid API

For instructions on how to use the Plaid API, please go to 
https://plaid.com/docs/llms.txt. There you can find a list of other
documentation pages that you can retrieve to obtain the necessary 
information. If you need to search for additional documentation, you
should first try to use a link that is listed in the llms.txt file.
`}</code></pre>
    <p>{`A single file containing all of Plaid's documentation can be found
at `}<a parentName="p" {...{
        "href": "https://plaid.com/docs/llms-full.txt"
      }}>{`https://plaid.com/docs/llms-full.txt`}</a>{`, although it is generally too large
to fit into most models' context windows. `}</p>
    <h5 {...{
      "id": "vibe-coding-guides"
    }}>{`Vibe coding guides`}</h5>
    <p>{`Trying to prompt your favorite LLM-powered coding tool to build a Plaid-powered
application? Plaid provides several `}<a parentName="p" {...{
        "href": "https://github.com/plaid/ai-coding-toolkit/tree/main/rules"
      }}>{`detailed guides`}</a>{` you
can reference within your LLM coding session that will provide your agent with
additional context. You can use these guides to more quickly build proof of concept
applications, or to kick-start your development process.`}</p>
    <h5 {...{
      "id": "vibe-coding-tips"
    }}>{`Vibe coding tips`}</h5>
    <p>{`Our `}<a parentName="p" {...{
        "href": "/docs/resources/vibe-coding"
      }}>{`vibe coding tips`}</a>{` article contains recommendations on how to get your favorite AI coding assistant or IDE to work best with Plaid, including common mistakes AI tools will make and how to fix them.`}</p>
    <h4 {...{
      "id": "ask-bill"
    }}>{`Ask Bill`}</h4>
    <p><a parentName="p" {...{
        "href": "/docs/support/?showChat=true"
      }}>{`Bill`}</a>{` is the helpful robot platypus that reads our docs for fun! You can `}<a parentName="p" {...{
        "href": "/docs/support/?showChat=true"
      }}>{`ask Bill`}</a>{` any time you need help with the Plaid API. Bill is also available as the `}<inlineCode parentName="p">{`search_documentation`}</inlineCode>{` tool in the `}<a parentName="p" {...{
        "href": "https://github.com/plaid/ai-coding-toolkit/tree/main/sandbox"
      }}>{`Plaid local MCP server`}</a>{`, so he can search Plaid's docs from inside your AI coding assistant. Remember that Bill (like all of us) isn't perfect, even though he tries his best -- he can sometimes make mistakes, and he can only provide answers based on Plaid's published documentation and other publicly available information sources.`}</p>
    <h4 {...{
      "id": "community"
    }}>{`Community`}</h4>
    <p>{`You can join the
`}<a parentName="p" {...{
        "href": "https://discord.gg/sf57M8DW3y"
      }}>{`Plaid Developer Community on Discord`}</a>{`.`}</p>
    <h4 {...{
      "id": "integration-support"
    }}>{`Integration support`}</h4>
    <p>{`For small businesses and startups, `}<a parentName="p" {...{
        "href": "https://www.humbledevs.com/"
      }}>{`HumbleDevs`}</a>{` is a popular Plaid integration partner offering affordable integration solutions. HumbleDevs offers several `}<a parentName="p" {...{
        "href": "https://v1.humbledevs.com/solutions"
      }}>{`pre-specced Plaid solutions packages`}</a>{` with known timelines and costs for popular Plaid-powered solutions, and can also build a custom Plaid integration. `}</p>
    <p>{`For larger businesses or those with other requirements, Plaid's partnerships team will work with you to understand your needs and recommend a partner that is a good fit for your business. For more information, contact your account manager or the `}<a parentName="p" {...{
        "href": "https://plaid.com/contact/"
      }}>{`sales team`}</a>{`. Or, if you already have Production access, you can `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/support/new/product-and-development/product-troubleshooting/developer-resources"
      }}>{`contact support`}</a>{` and select "Building with Plaid" followed by "Plaid Partner Implementation Assistance". `}</p>
    <p>{`At the enterprise level, Plaid also offers integration packages. For more details, `}<a parentName="p" {...{
        "href": "https://plaid.com/contact/"
      }}>{`contact sales`}</a>{` or your account manager. `}</p>
    <h4 {...{
      "id": "partner-directory"
    }}>{`Partner directory`}</h4>
    <p>{`For more information about Plaid partners, see the
`}<a parentName="p" {...{
        "href": "https://plaid.com/partner-directory/"
      }}>{`Partner directory`}</a>{`.`}</p>
    <p>{`The Partner directory is not a comprehensive list of all Plaid partners; if you don't see the partnership you're looking for, contact your account manager or the `}<a parentName="p" {...{
        "href": "https://plaid.com/contact/"
      }}>{`sales team`}</a>{`. `}</p>
    <h4 {...{
      "id": "security-portal-audits-and-certifications"
    }}>{`Security portal, audits, and certifications`}</h4>
    <p>{`For a high-level overview of information on Plaid's privacy and security practices for developers, see `}<a parentName="p" {...{
        "href": "https://plaid.com/safety/"
      }}>{`Plaid Safety`}</a>{`. `}</p>
    <p>{`For details on Plaid's current certifications, audit results, and the security knowledge base, see the `}<a parentName="p" {...{
        "href": "https://security.plaid.com/"
      }}>{`Security Portal`}</a>{`.`}</p>
    <p>{`Plaid maintains a `}<a parentName="p" {...{
        "href": "https://hackerone.com/plaid"
      }}>{`HackerOne bug bounty program`}</a>{` for security researchers.`}</p>
    <h4 {...{
      "id": "bank-coverage-explorer"
    }}>{`Bank Coverage Explorer`}</h4>
    <p>{`For a detailed chart showing Plaid's coverage by bank and product, see the `}<a parentName="p" {...{
        "href": "/docs/institutions"
      }}>{`US and Canada Bank Coverage Explorer`}</a>{` and the `}<a parentName="p" {...{
        "href": "/docs/institutions/europe"
      }}>{`European Bank Coverage Explorer`}</a>{`.`}</p>
    <h4 {...{
      "id": "third-party-resources"
    }}>{`Third-party resources`}</h4>
    <p>{`Several third party developers have built resources to help you integrate with
Plaid. Note that these resources are not built or supported by Plaid, and
inclusion of a resource on the list below does not constitute an endorsement by
Plaid or indicate that Plaid has evaluated the resource for correctness,
security, or anything else.`}</p>
    <p>{`If you have a third-party resource you'd like to be featured on this list, DM us
`}<a parentName="p" {...{
        "href": "https://twitter.com/plaiddev"
      }}>{`@plaiddev`}</a>{` on X, or reach out to an admin
on the `}<a parentName="p" {...{
        "href": "https://discord.gg/sf57M8DW3y"
      }}>{`Plaid Developer Discord`}</a>{`.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://aws.amazon.com/blogs/apn/how-to-build-a-fintech-app-on-aws-using-the-plaid-api/"
        }}>{`How to Build a Fintech app on AWS using the Plaid API`}</a>{`
and the accompanying
`}<a parentName="li" {...{
          "href": "https://github.com/aws-samples/aws-plaid-demo-app"
        }}>{`sample app`}</a>{` demonstrates
how to build a Plaid app on AWS, using the latest Transactions Sync API. The
app and tutorial incorporate AWS Lambda for webhook handling and Amazon
Cognito for authentication.`}</li>
      <li parentName="ul">{`The `}<a parentName="li" {...{
          "href": "https://github.com/topics/plaid"
        }}>{`Plaid tag on GitHub`}</a>{` contains multiple example apps using Plaid.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.webhookdb.com/guides/plaid/"
        }}>{`WebhookDB`}</a>{` has a tutorial showing how to
use their service to manage Plaid webhooks.`}</li>
      <li parentName="ul">{`The `}<a parentName="li" {...{
          "href": "https://www.cloudquery.io/hub/plugins/source/cloudquery/plaid/latest/docs"
        }}>{`CloudQuery Plaid plugin`}</a>{`
extracts data from Plaid and loads it into any supported CloudQuery
destination, such as PostgreSQL, Snowflake, BigQuery, or S3.`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "sample-apps",
        level: 4,
        title: "Sample apps",
      },
{
        id: "demos-video-tutorials-and-guides",
        level: 4,
        title: "Demos, video tutorials, and guides",
      },
{
        id: "developer-tools",
        level: 4,
        title: "Developer tools",
      },
{
        id: "ai-developer-tools",
        level: 4,
        title: "AI developer tools",
      },
{
        id: "ask-bill",
        level: 4,
        title: "Ask Bill",
      },
{
        id: "community",
        level: 4,
        title: "Community",
      },
{
        id: "integration-support",
        level: 4,
        title: "Integration support",
      },
{
        id: "partner-directory",
        level: 4,
        title: "Partner directory",
      },
{
        id: "security-portal-audits-and-certifications",
        level: 4,
        title: "Security portal, audits, and certifications",
      },
{
        id: "bank-coverage-explorer",
        level: 4,
        title: "Bank Coverage Explorer",
      },
{
        id: "third-party-resources",
        level: 4,
        title: "Third-party resources",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
